// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/common/ColorLegend.scss
// module id = 1302
// module chunks = 0